<div class="fill-height p-2">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <mat-card>
    <form class="h-100 d-flex flex-column p-2" [formGroup]="form" (submit)="onSaveProduct()" *ngIf="!isLoading">

      <mat-form-field>
        <mat-label>{{ "su-management.products_serial-name" | translate }}</mat-label>
        <input matInput type="text" formControlName="serial_name"
          [placeholder]="'su-management.products_serial-name' | translate">
        <mat-error *ngIf="form.get('serial_name').invalid">
          <span>{{ "su-management.products_please-enter" | translate }} </span>
          <span>{{ "su-management.products_serial-name" | translate }}.</span>
        </mat-error>
      </mat-form-field>

      <mat-checkbox [(ngModel)]="form.value.close" formControlName="close">
        {{ "su-management.products_close" | translate }}
      </mat-checkbox>

      <mat-form-field>
        <mat-label>{{ "su-management.products_close_msg" | translate }}</mat-label>
        <input matInput type="text" formControlName="close_msg"
          [placeholder]="'su-management.products_close_msg' | translate">
        <mat-error *ngIf="form.get('close_msg').invalid">
          <span>{{ "su-management.products_please-enter" | translate }} </span>
          <span>{{ "su-management.products_close_msg" | translate }}.</span>
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "su-management.products_domain" | translate }}</mat-label>
        <input matInput type="text" formControlName="domain"
          [placeholder]="'su-management.products_domain' | translate">
        <mat-error *ngIf="form.get('domain').invalid">
          <span>{{ "su-management.products_please-enter" | translate }} </span>
          <span>{{ "su-management.products_domain" | translate }}.</span>
        </mat-error>
      </mat-form-field>

      <mat-checkbox [(ngModel)]="form.value.downgraded" formControlName="downgraded">
        {{ "su-management.products_downgraded" | translate }}
      </mat-checkbox>

      <mat-form-field>
        <mat-label>{{ "su-management.products_alert-email" | translate }}</mat-label>
        <input matInput type="text" formControlName="email"
          [placeholder]="'su-management.products_alert-email' | translate">
        <mat-error *ngIf="form.get('email').invalid">
          <span>{{ "su-management.products_please-enter" | translate }} </span>
          <span>{{ "su-management.products_alert-email" | translate }}.</span>
        </mat-error>
      </mat-form-field>

      <mat-checkbox [(ngModel)]="form.value.hide" formControlName="hide">
        {{ "su-management.products_hide" | translate }}
      </mat-checkbox>

      <mat-form-field>
        <mat-label>{{ "su-management.products_hotjarID" | translate }}</mat-label>
        <input matInput type="text" formControlName="hotjarID"
          [placeholder]="'su-management.products_hotjarID' | translate">
        <mat-error *ngIf="form.get('hotjarID').invalid">
          <span>{{ "su-management.products_please-enter" | translate }} </span>
          <span>{{ "su-management.products_hotjarID" | translate }}.</span>
        </mat-error>
      </mat-form-field>

      <mat-checkbox [(ngModel)]="form.value.inform_slack_of_new_orders" formControlName="inform_slack_of_new_orders">
        {{ "su-management.products_inform-slack" | translate }}
      </mat-checkbox>

      <mat-form-field>
        <mat-label>{{ "su-management.products_location" | translate }}</mat-label>
        <input matInput type="text" formControlName="location"
          [placeholder]="'su-management.products_location' | translate">
        <mat-error *ngIf="form.get('location').invalid">
          <span>{{ "su-management.products_please-enter" | translate }} </span>
          <span>{{ "su-management.products_location" | translate }}.</span>
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "su-management.products_name-old" | translate }}</mat-label>
        <input matInput type="text" formControlName="name"
          [placeholder]="'su-management.products_name-old' | translate">
        <mat-error *ngIf="form.get('name').invalid">
          <span>{{ "su-management.products_please-enter" | translate }} </span>
          <span>{{ "su-management.products_name-old" | translate }}.</span>
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "su-management.products_short_name" | translate }}</mat-label>
        <input matInput type="text" formControlName="short_name"
          [placeholder]="'su-management.products_short_name' | translate">
        <mat-error *ngIf="form.get('short_name').invalid">
          <span>{{ "su-management.products_please-enter" | translate }} </span>
          <span>{{ "su-management.products_short_name" | translate }}.</span>
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "su-management.products_slack_url" | translate }}</mat-label>
        <input matInput type="text" formControlName="slack_url"
          [placeholder]="'su-management.products_slack_url' | translate">
        <mat-error *ngIf="form.get('slack_url').invalid">
          <span>{{ "su-management.products_please-enter" | translate }} </span>
          <span>{{ "su-management.products_slack_url" | translate }}.</span>
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "su-management.products_sort" | translate }}</mat-label>
        <input matInput type="number" formControlName="sort" [placeholder]="'su-management.products_sort' | translate">
        <mat-error *ngIf="form.get('sort').invalid">
          <span>{{ "su-management.products_please-enter" | translate }} </span>
          <span>{{ "su-management.products_sort" | translate }}.</span>
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'su-management.paper.types' | translate }}</mat-label>
        <mat-select formControlName="papers" multiple>
          <mat-option *ngFor="let paper of availablePaperTypes" [value]="paper.id">
            {{ "paper-type.name." + paper.paper.paperType | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- ADD EDIT BRANCH PROPERTIES HERE 1: -->

      <!-- <div>
        <button mat-stroked-button type="button" (click)="filePicker.click()">Pick Image</button>
        <input type="file" #filePicker (change)="onImagePicked($event)">
      </div>
      <div class="image-preview" *ngIf="imagePreview !== '' && imagePreview && form.get('image').valid">
        <img [src]="imagePreview" [alt]="form.value.title">
      </div>
      <mat-checkbox [(ngModel)]="form.value.isExpress" formControlName="isExpress">isExpress</mat-checkbox>
      <mat-checkbox [(ngModel)]="form.value.isPlotter" formControlName="isPlotter">isPlotter</mat-checkbox>
      <mat-checkbox [(ngModel)]="form.value.isPh" formControlName="isPh">isPh</mat-checkbox>
      <mat-form-field>
        <mat-label>Paper Types</mat-label>
        <mat-select formControlName="papers" multiple>
          <mat-option *ngFor="let paperType of availablePaperTypes" [value]="paperType.id">
            {{ paperType.paperName }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <button #hiddenSubmitBtn type="submit" style="display: none;"></button>

    </form>
  </mat-card>
</div>

<div class="p-2">
  <div class="d-flex flex-column flex-md-row gap-2">
    <button class="w-100 rounded-pill text-white" mat-raised-button color="primary" type="button"
      (click)="submitForm()">
      {{ "su-management.products_save-product" | translate }}
    </button>
    <button class="w-100 rounded-pill text-white" *ngIf="isModeEdit" mat-raised-button color="primary" type="button"
      (click)="backToProducts()">
      {{ "su-management.products_dont-Save-chagnes" | translate }}
    </button>
    <button class="w-100 rounded-pill" mat-raised-button type="button" (click)="toProductsList()">
      {{ "su-management.products_products-list" | translate }}
    </button>
  </div>
</div>